//-----------------
// combatant names
//-----------------
export default function combatantNames(combatants) {
  const names_array = combatants.map(function (array) {
    return array.name;
  });
  return names_array;
}
